export type EnglishIqV2DeviceType = 'android' | 'desktop' | 'ios';

export function resolveEnglishIqV2Device(userAgent: string): EnglishIqV2DeviceType {
  if (/android/i.test(userAgent)) {
    return 'android';
  }
  if (/iphone|ipad|ipod/i.test(userAgent)) {
    return 'ios';
  }
  return 'desktop';
}
